import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AuthWrapper2/hooks/useCurrentUser.ts
function useCurrentUser() {
	return useSingleton(AuthViewModel).state.identityInfo.user;
}
//#endregion
export { useCurrentUser };

//# sourceMappingURL=useCurrentUser.js.map